import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { CadastroClienteModal } from './CadastroClienteModal';
import { LoginClienteModal } from './LoginClienteModal';
import './ClienteAuthModal.css';

interface ClienteAuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export const ClienteAuthModal: React.FC<ClienteAuthModalProps> = ({ 
  isOpen, 
  onClose, 
  onSuccess 
}) => {
  const [showCadastro, setShowCadastro] = useState(false);
  const [showLogin, setShowLogin] = useState(true); // Começar com login

  const handleSwitchToCadastro = () => {
    setShowLogin(false);
    setShowCadastro(true);
  };

  const handleSwitchToLogin = () => {
    setShowCadastro(false);
    setShowLogin(true);
  };

  const handleCadastroSuccess = () => {
    setShowCadastro(false);
    setShowLogin(false);
    onSuccess?.();
    onClose();
  };

  const handleLoginSuccess = () => {
    setShowLogin(false);
    setShowCadastro(false);
    onSuccess?.();
    onClose();
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  // Se mostrar cadastro, renderizar o modal de cadastro
  if (showCadastro) {
    return (
      <CadastroClienteModal
        isOpen={showCadastro}
        onClose={() => {
          setShowCadastro(false);
          if (!showLogin) {
            onClose();
          }
        }}
        onSuccess={handleCadastroSuccess}
        onSwitchToLogin={handleSwitchToLogin}
      />
    );
  }

  // Se mostrar login, renderizar o modal de login
  if (showLogin) {
    return (
      <LoginClienteModal
        isOpen={showLogin}
        onClose={() => {
          setShowLogin(false);
          if (!showCadastro) {
            onClose();
          }
        }}
        onSuccess={handleLoginSuccess}
        onSwitchToCadastro={handleSwitchToCadastro}
      />
    );
  }

  return null;
};

